import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { DatastoreService } from '../datastore.service';
@Injectable({
	providedIn: 'root',
})
export class BasketService {
	private core = AppConfig.settings.core;
	private apiServer = AppConfig.settings.apiServer;
	currentBasket;
	purchase;
	currentServiceItem;

	constructor(
		private http: HttpClient,
		private datastoreService: DatastoreService
	) {}

	async createBasket(selectedLocation) {
		const company = selectedLocation;
		this.currentBasket = await company.$post('baskets', {
			company_id: company.id,
		});
		return this.currentBasket;
	}

	async getCurrentBasket(selectedLocation) {
		const company = selectedLocation;
		const baseBasketResource = await company.$get('baskets', {
			company_id: company.id,
		});
		const baskets = await baseBasketResource.$get('baskets');
		this.currentBasket = baskets[baskets.length - 1];
		return baskets[baskets.length - 1];
	}

	async deleteAllBaskets(selectedLocation) {
		const company = selectedLocation;
		if (!company.$has('baskets')) {
			return null;
		}

		const baskets = await this.checkForExistingBaskets(selectedLocation);

		if (baskets.length >= 1) {
			for (const basket of baskets) {
				new Promise(() => {
					company.$del('baskets', { basket_id: basket.id }).then(() => {
						Promise.resolve();
					});
				});
			}
		}
	}

	async checkForExistingBaskets(selectedLocation) {
		const company = selectedLocation;
		if (company.$has('baskets')) {
			const baseBasketResource = await company.$get('baskets', {
				company_id: company.id,
			});
			const baskets = await baseBasketResource.$get('baskets');
			return baskets;
		}
	}

	async addItem(
		selectedLocation,
		service_id,
		duration,
		start,
		questions,
		resource_id = null
	) {
		const company = selectedLocation;
		if (company.$has('baskets')) {
			try {
				const item = await this.currentBasket.$post(
					'service_items',
					{},
					{
						service_id,
						duration,
						start,
						company_id: company.id,
						basket_id: this.currentBasket.id,
						questions,
						resource_id,
					}
				);
				return item;
			} catch (error) {
				return 'failed';
			}
		}
	}

	checkoutBasket(selectedLocation, client, notifications) {
		const company = selectedLocation;
		if (company.$has('baskets')) {
			try {
				return this.currentBasket
					.$post(
						'checkout',
						{},
						{
							client,
							is_admin: this.datastoreService.adminJourney ? true : false,
							basket_id: this.currentBasket.id,
							no_notifications: notifications,
							settings: {
							  "firstAvailableSlot": this.datastoreService.firstSlotAnalytic ? this.datastoreService.firstSlotAnalytic : "Null"
							},
						}
					)
					.then((res) => {
						this.purchase = res;
						return res;
					});
			} catch (error) {
				return 'failed';
			}
		}
	}

	async getPurchase() {
		return this.purchase;
	}

	async reassignCompany(company: any) {
		console.log(`reassigning company to: `, company.id);
		const authToken = localStorage.getItem('auth_token');
		const headers: HttpHeaders = new HttpHeaders({
			'App-Id': this.core.app_id,
			'App-Key': this.core.app_key,
			'Auth-Token': authToken,
		});
		const apiUrl = `${this.apiServer.api_url}/api/${this.apiServer.version}/login/admin`;
		const body = {
			company_id: company.id,
		};
		const attach = await this.http.put(apiUrl, body, { headers }).toPromise();
		return attach;
	}

	async addAttachement(purchase, bookings, formData) {
		const headers: HttpHeaders = new HttpHeaders({
			'App-Id': this.core.app_id,
			'App-Key': this.core.app_key,
		});
		const apiUrl = `${this.apiServer.api_url}/api/${this.apiServer.version}/purchases/${purchase.long_id}/bookings/${bookings[0].id}/attach`;
		const attach = await this.http
			.post(apiUrl, formData, { headers })
			.toPromise();
		return attach;
	}

	async delete(company, basket) {
		if (!company.$has('baskets')) return null;
		return company.$del('baskets', { basket_id: basket.id });
	}

	async checkoutBasketV1(selectedLocation, client, notifications) {
		const company = selectedLocation;
		const isAdmin = this.datastoreService.adminJourney ? true : false;
		if (company.$has('baskets')) {
			try {
				let channel = this.datastoreService.adminJourney ? 'admin' : 'client';
				// const authToken = (this.datastoreService.adminJourney && this.datastoreService.adminAuthToken.length > 0) ? this.datastoreService.adminAuthToken : localStorage.getItem('auth_token');
				const authToken = localStorage.getItem('auth_token');
				const headers: HttpHeaders = new HttpHeaders({
					'App-Id': this.core.app_id,
					'App-Key': this.core.app_key,
					'Auth-Token': authToken,
				});
				const apiUrl = `${this.apiServer.api_url}/api/v1/${selectedLocation.id}/basket/checkout?member_id=${client.id}`;
				const checkout = await this.http
					.post(
						apiUrl,
						{
							client: client,
							is_admin: isAdmin,
							no_notifications: notifications,
							settings: {
								channel: channel,
								"firstAvailableSlot": this.datastoreService.firstSlotAnalytic ? this.datastoreService.firstSlotAnalytic : "Null"
							},
						},
						{ headers }
					)
					.toPromise();
				console.log(checkout);
				this.purchase = checkout;
				return checkout;
			} catch (error) {
				return 'failed';
			}
		}
	}

	/**
	 * Resolve the JRNI resource_id for a basket call.
	 *
	 * datastoreService.selectedSuggestion.resource_id is the source of truth when set;
	 * otherwise fall back to the candidates the caller supplied.
	 * Callers have historically passed the whole resource OBJECT rather than its id, and
	 * parseInt(object) is NaN — which serialises to null, and JRNI then silently assigns
	 * whatever resource is free at that slot, booking the customer into the wrong room.
	 * Accept an id or an object for each candidate, take the first usable one, and return
	 * null (never NaN, never 0) when there is genuinely no resource to send.
	 */
	private resolveResourceId(...candidates: any[]): number | null {
		const suggested = Number(this.datastoreService.selectedSuggestion?.resource_id);
		if (suggested > 0) {
			return suggested;
		}
		for (const candidate of candidates) {
			const id = Number(candidate && typeof candidate === 'object' ? candidate.id : candidate);
			if (id > 0) {
				return id;
			}
		}
		return null;
	}

	async addItemV1(
		selectedLocation,
		service_id,
		duration,
		start,
		questions,
		member_id,
		resource_id = null
	) {
		const company = selectedLocation;
		try {
			// const authToken = (this.datastoreService.adminJourney && this.datastoreService.adminAuthToken.length > 0) ? this.datastoreService.adminAuthToken : localStorage.getItem('auth_token');
			const authToken = localStorage.getItem('auth_token');
			const headers: HttpHeaders = new HttpHeaders({
				'App-Id': this.core.app_id,
				'App-Key': this.core.app_key,
				'Auth-Token': authToken,
			});

			let apiUrl = `${this.apiServer.api_url}/api/v1/${selectedLocation.id}/basket/add_item`;
			if (member_id) {
				apiUrl = `${apiUrl}?member_id=${member_id}`;
			}
			const addItem = await this.http
				.post(
					apiUrl,
					{
						entire_basket: true,
						items: [
							{
								datetime: start,
								duration: duration,
								service_id: service_id,
								questions: questions,
								resource_id: this.resolveResourceId(resource_id),
								status: this.datastoreService.serviceBookingType,
							},
						],
					},
					{ headers }
				)
				.toPromise();
			this.currentBasket = addItem;
			console.log(addItem);
			return addItem;
		} catch (err) {
			console.error(err);
			throw err;
		}
	}

	async updateItemV1(
		selectedLocation,
		service_id,
		duration,
		start,
		questions,
		member_id,
		resource_id = null
	) {
		const authToken = localStorage.getItem('auth_token');
		const headers: HttpHeaders = new HttpHeaders({
			'App-Id': this.core.app_id,
			'App-Key': this.core.app_key,
			'Auth-Token': authToken,
		});
		// first we delete the basket, then we re-make it
		const apiUrl = `${this.apiServer.api_url}/api/v1/${selectedLocation.id}/basket/`;
		let delItem;
		try {
			const delBasketUrl = `${apiUrl}${this.currentBasket._embedded.items[0].id}`;
			delItem = await this.http.delete(delBasketUrl, { headers }).toPromise();
			console.log(delItem);
		} catch (err) {
			console.error(err);
		}
		if (delItem) {
			return await this.addItemV1(
				selectedLocation,
				service_id,
				duration,
				start,
				questions,
				member_id,
				resource_id
			);
		}
	}
}
